<div class="content">
    <p>Can't create new user!</p>
    <h3>
        The Email has already been taken, Please try with another email id.
    </h3>
    <button mat-raised-button color="primary" (click)="onNoClick()">Ok</button>
</div>